import type { PostStatus } from '~publish/components/graphqlEnums'
import { buildPostPermalinkTarget } from '~publish/components/PostPermalink'
import { isOfType } from '~publish/helpers/typeGuards'
import { scheduleDraftDetails } from '~publish/legacy/routes'

export type DraftPermalinkContentItem = {
  id: string
  body:
    | { __typename: 'DraftContent' }
    | {
        __typename: 'PostContent'
        posts: ReadonlyArray<{
          id: string
          status: PostStatus
          channelId: string
        }>
      }
}

/**
 * A draft that has since been given channels is no longer channel-less, so the
 * link follows it to the post it became. `null` means the reader can view none
 * of those channels: the API scopes the posts to the ones they may see.
 */
export const buildDraftPermalinkTarget = (
  contentItem: DraftPermalinkContentItem,
): string | null => {
  const { body } = contentItem

  if (isOfType(body, 'PostContent')) {
    const [post, ...siblings] = body.posts

    if (!post) {
      return null
    }

    return buildPostPermalinkTarget({
      id: post.id,
      status: post.status,
      channelId: post.channelId,
      hasSiblingPosts: siblings.length > 0,
    })
  }

  return scheduleDraftDetails.getRoute({ contentItemId: contentItem.id })
}
